import MissionShow from "../components/mission/Show";

export default [
  { name: 'Mission', path: '/mission', component: MissionShow,  }
]
